import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Typography } from '@mui/material';
import usePersonSummary from '../../hooks/usePersonSummary';
import Section from '../Section';
import * as S from './DataSection.styles';
export const DataSection = ({
  summary
}) => {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const data = usePersonSummary(summary);
  const active = data.filter(item => item.active);
  useEffect(() => {
    active.map(item => router.prefetch(item.link));
  }, [router.prefetch]);
  return /*#__PURE__*/React.createElement(Section, {
    title: t('b2c.home.subheading.data')
  }, /*#__PURE__*/React.createElement(S.Container, {
    length: active.length
  }, active.map(item => /*#__PURE__*/React.createElement(S.Item, {
    key: item.title,
    onClick: () => router.push(item.link)
  }, item.Icon, /*#__PURE__*/React.createElement(S.Wrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "Lato Emphasized 1"
  }, item.title), /*#__PURE__*/React.createElement(Typography, {
    variant: "Lato Body 2"
  }, item.text))))));
};